import { css } from "styled-components";

export const globalStyle = {
    css: css`

        body{
            overflow-x: hidden;
        }

        main {

            @media (min-width: 992px) {
                padding-left: 30px !important;
                padding-right: 30px !important;
            }
        }

        * {
        
            &:focus{
                outline: 0 !important;
            }
        }

        .home-page-link{
            transition: outline 0.2s ease;
        
            &:focus {
                outline: 2px solid ${({ theme }) => theme.colors.primary.main} !important;
                outline-offset: -2px;
            }
        }

        button{
            border-width: 1px !important;
        }

        input, select, textarea{
            font-size: 16px !important;
            border-radius: 7px !important;
        
            &:focus{
                border-color: ${({ theme }) => theme.colors.primary.main} !important;
            }
        }

        legend {
            padding-inline-start: 0;
            padding-inline-end: 0;
        }

        // Global styles for Select labels
        [class^="FormFieldStyle-sc-"] label,
        [class*="FormFieldStyle-sc-"] label {
            padding: 9px 15px 0 0;
        }

        .react-datetime-picker{
        
            &:focus-within{
                border-color: ${({ theme }) => theme.colors.primary.main} !important;
            }

            &__calendar-button{

                &:focus{

                    [class^="IconWrapper-sc-"]{
                        outline: 0 !important;
                    }
                }
            }
        }

        select{
            line-height: 1.2;
        }

        [data-test-selector="pageBreadcrumbs"]{
            flex-wrap: wrap;

            a{
                
                &:first-child{

                    span{
                        overflow: hidden;
                        width: 34px;
                        white-space: nowrap;
                    }
                }
            }
        }

        [data-test-selector="previouslyPurchasedProductsFilter"],
        [data-test-selector="searchWithinFilter"]{
            align-items: center;
        }

        // hover fixed primary buttons
        [data-test-selector="checkoutShippingCartTotalContinueButton"],
        [data-test-selector="checkoutShipping_continue"],
        [data-test-selector="savedOrderDetails_placeOrder"],
        [data-test-selector="checkoutReviewAndSubmit_placeOrder"],
        [data-test-selector="shareEntity_submit"],
        [data-test-selector="myLists_submitNoteButton"],
        [data-test-selector="sendButton"],
        [data-test-selector="orderDetails_reorderButton"],
        [data-test-selector="cart_saveOrder"],
        [data-test-selector="rfqQuoteDetails_deleteQuote"],
        [data-test-selector="rfqQuoteDetails_submitQuote"],
        [data-test-selector="quoteDetails_QuoteButton"],
        [data-test-selector="rfqQuoteDetails_managerApproveQuote"],
        [data-test-selector="rfqQuoteDetails_managerDeclineQuote"],
        [data-test-selector="rfqQuoteDetails_acceptQuote"],
        [data-test-selector="rfqQuoteDetails_declineQuote"]{
        
            &:hover{
            
                span{
                    color: ${({ theme }) => theme.colors.primary.contrast};
                }
            }
        }

        // primary button styles overridden
        [data-test-selector="QuoteInCartMessageSubmit"],
        [data-test-selector^="wishListAddToCartButton_"],
        [data-test-selector="useAs_Shipping_Address"],
        [data-test-selector="orderHistoryTable_Reorder"],
        [data-test-selector="expandMobileMenu"],
        [data-test-selector="myLists_createListButton"],
        [data-test-selector="myListsListSubmitDelete"]{
            color: ${({ theme }) => theme.colors.primary.main};
            border: ${({ theme }) => theme.colors.primary.main} solid 1px;

            &:hover{
                
                span{
                    color: ${({ theme }) => theme.colors.primary.contrast};
                }
            }
        }

        // secondary button styles overridden
        [data-test-selector="customerAddressForm_cancel"],
        [data-test-selector="shareEntity_email"],
        [data-test-selector="editListForm"] button:first-child,
        [data-test-selector="myListsAddTagsFormCancel"]{
            color: ${({ theme }) => theme.colors.secondary.contrast};
            border: ${({ theme }) => theme.colors.secondary.contrast} solid 1px;

            &:hover{
            
                background-color: ${({ theme }) => theme.colors.primary.contrast} !important;
                border: ${({ theme }) => theme.colors.secondary.contrast} solid 1px;

                span{
                    color: ${({ theme }) => theme.colors.primary.main};
                }
            }
        }

        [data-test-selector="expandMobileMenu"]{
        
            span{
                color: ${({ theme }) => theme.colors.primary.main} !important;
            }

            &:hover{
                
                span{
                    color: ${({ theme }) => theme.colors.primary.contrast} !important;
                }
            }
        }

        .popover{
        
            &[id^="headerSearch-"]{
                top: 12% !important;
            }
        }

        [data-test-selector="shareEntity_email"]{

            @media (max-width:768px){
                border: none;
            }
        }

        [data-test-selector="orderHistory_filterDateRange"]{
            gap: 10px;

            & > div{
                width: 50%;
            }
        }

        // Calendar input width correction
        [data-test-selector="rfqMyQuotes_fromDateFilter"],
        [data-test-selector="rfqMyQuotes_toDateFilter"],
        [data-test-selector="rfqMyQuotes_expireFromDateFilter"],
        [data-test-selector="rfqMyQuotes_expireToDateFilter"],
        [data-test-selector="myLists_fromCreatedDate"],
        [data-test-selector="myLists_toCreatedDate"],
        [data-test-selector="myLists_fromUpdatedOn"],
        [data-test-selector="myLists_toUpdatedOn"],
        [data-test-selector="savedOrderList_fromDateFilter"],
        [data-test-selector="savedOrderList_toDateFilter"]{

            & > div{
                width: 100%;
            }
        }

        [data-test-selector="myLists_toUpdatedOn"]{

            @media (min-width: 768px) and (max-width: 992px){
                padding-left: 0;

                & > div{
                    padding-left: 0;
                }
            }
        }

        [data-test-selector="myListDetails_addListToCart"]{

            span{
                font-weight: normal;
            }
        }

        [data-test-selector="productDetails_leftColumn"]{
            margin-bottom: 32px !important;
        }
        
        [data-test-selector="cartTotal_checkout"],
        [data-test-selector="checkoutShipping_continue"]{

            @media (max-width:575px){
                background-color: ${({ theme }) => theme.colors.primary.contrast};
                margin: 15px;
                width: calc(100% - 30px);
            }
        }
        
        [data-test-selector="checkoutReviewAndSubmit_backButton"],
        [data-test-selector="checkoutReviewAndSubmit_placeOrder"]{

            @media (max-width:575px){
                margin: 15px;
                flex-shrink: 1;
            }
        }

        [data-test-selector="addressSuggestionModal"]{
            animation: none !important;
            transition: none !important;
        }
            
        [data-test-selector="homePage"]{
        
            @media (min-width: 576px) and (max-width: 767px) {
                max-width: inherit;
            }
        }

        // Drawer Styles
        [class^="DrawerContent-sc-"] {

            [data-test-selector^="attributeValueFilter"],
            [data-test-selector="productListClearAll"] {
                width: 100%;
            }           
        }

        // NavigationDrawer Panel Styles - z-index for category submenus
        [class^="PanelChildren-sc-"][data-layer] {
            z-index: 1;
        }

        // Home Titles
        [data-test-selector="homePage"] {

            h4 {
                font-size: 36px;
                font-weight: 800;
                line-height: 1;
                margin-bottom: 45px !important;

                @media (max-width:768px){
                    font-size: 22px;
                    font-weight: 600;
                }
            }
        
            h5 {
                font-size: 14px;
                color: ${({ theme }) => theme.colors.primary.main};
                text-transform: uppercase;
                line-height: 1;
                position: relative;
                padding-left: 12px;
                margin-bottom: 10px;

                &:before {
                    content: "";
                    position: absolute;
                    background-color: ${({ theme }) => theme.colors.primary.main};
                    width: 4px;
                    height: 16px;
                    top: 0;
                    left: 0;
                }
            }
        }

    `,
};